export default __webpack_public_path__ + "static/media/2017 DEC ZURY PASSION-03.d4614d7e.jpg";